// ======================================================================
// File Name       : ContentQuestionCommonInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { FormControl, Col, Form } from 'react-bootstrap';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import SelectBox from '../../components/SelectBox';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';

class ContentQuestionCommonInfo extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.validation = this.validation.bind(this);
  }
  onChange(event, data) {
    if (data === undefined) {
      const { name, value } = event.target;
      this.props.onInputChange(name, value);
    } else {
      this.props.onInputChange(event, data);
    }
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      questionSecernId,
      questionTitle,
      onInputChange,
      questionKind,
      onchageQuestionType,
    } = this.props;
    this.refsToValidate = [];
    return (
      <div>
        <Col sm={12} className="padding-left-clear">登録する項目を指定してください</Col>
        <Col as={Form.Label} sm={12} className="margin-top-20 margin-bottom-10">
          基本設定
        </Col>
        <Col sm={12}>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              問題形式
            </Col>
            <Col sm={7}>
              <SelectBox
                data={SELECT_BOX_DATA.QUESTION_TYPE}
                name="questionKind"
                value={questionKind}
                onChange={(event) => {
                  if (event && event.target) {
                    const { value } = event.target;
                    onchageQuestionType(value);
                  }
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              問題識別ID
            </Col>
            <Col sm={7}>
              <FormControlValidate
                type="text"
                name="questionSecernId"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                label={'問題識別ID'}
                value={questionSecernId}
                onChange={this.onChange}
                maxLength={64}
                validateType={VALIDATE_TYPE.ID}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              問題タイトル<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7}>
              <FormControlValidate
                label={'問題タイトル'}
                type="text"
                name="questionTitle"
                value={questionTitle}
                onChange={this.onChange}
                maxLength="256"
                required
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
              />
            </Col>
          </Form.Group>
        </Col>
      </div>
    );
  }
}

export default ContentQuestionCommonInfo;
